define((require) => {
    "use strict";

    var _                                   = require("underscore"),
        ImprovedView                        = require("editor/zbone/ImprovedView"),
        ConcatenatedCollection              = require("zbone/ConcatenatedCollection"),
        EditorEvents                        = require("shared/services/EditorEvents"),
        EmailUtil                           = require("util/EmailUtil"),
        FilteredCollection                  = require("zbone/FilteredCollection"),
        LoggedIn                            = require("shared/security/LoggedIn"),
        LoggedInUserState                   = require("shared/ui/user/LoggedInUserState"),
        ShareRecipient                      = require("ui/share/ShareRecipient"),
        ShareRecipientDisplayCollectionView = require("ui/share/ShareRecipientDisplayCollectionView"),
        ShareRecipientCollectionView        = require("ui/share/ShareRecipientCollectionView"),
        ShareRecipientToLabel               = require("ui/share/ShareRecipientToLabel"),
        template                            = require("ui/share/ShareMenu.tpl"),
        UserCollection                      = require("ui/user/UserCollection");

    /**
     * The share menu.
     *
     * @author Bruce Mackenzie Nielsen
     * @class ShareMenu
     * @constructor
     */
    return ImprovedView.extend({

        template: template,

        className: "share-menu",

        events: {
            "click .choose-recipients-ok": function() {
                this.ui.chooseRecipientsWrapper.collapse("hide");
            },
            "click .share-cancel": function() {
                this.model.set("state", 0);
            },
            "click .share-send": "_send",
            "click .choose-recipients-add-button": function() {
                this.ui.recipientsAddButton.hide();
                this.ui.recipientsAddInputContainer.css("visibility", "visible");
                this.ui.recipientsAddInput.focus();
            },
            "click .choose-recipients-add-ok": "_addRecipient",
            "keyup .choose-recipients-add input": function(event) {
                // Escape
                if (event.keyCode === 27) {
                    this.ui.recipientsAddButton.show();
                    this.ui.recipientsAddInputContainer.css("visibility", "hidden");
                    return;
                }

                // Enter
                if (event.keyCode === 13) {
                    this._addRecipient();
                }
                if (this._validateInviteEmail()) {
                    this.ui.recipientsAddOkButton.addClass("valid");
                } else {
                    this.ui.recipientsAddOkButton.removeClass("valid");
                }
            },
            "click": function(event) {
                if (!this.ui.recipientsAdd[0].contains(event.target)) {
                    this.ui.recipientsAddButton.show();
                    this.ui.recipientsAddInputContainer.css("visibility", "hidden");
                }
            }
        },

        modelEvents: {
            "change:message": "_updateValidationStates"
        },

        bindings: {
            "textarea": "message"
        },

        ui: {
            recipientsList: ".choose-recipients-list-region",
            recipientsAdd: ".choose-recipients-add",
            recipientsAddButton: ".choose-recipients-add-button",
            recipientsAddInputContainer: ".choose-recipients-add-input-container",
            recipientsAddInput: ".choose-recipients-add-input-wrapper input",
            recipientsAddOkButton: ".choose-recipients-add-ok",
            recipientsOkButton: ".choose-recipients-ok",
            recipientsFooter: ".footer",
            chooseRecipients: ".choose-recipients-body",
            chooseRecipientsWrapper: "#choose-recipients-body-container",
            sendButton: ".share-send button"
        },

        regions: {
            recipientsDisplay: ".recipients-list",
            recipientsList: ".choose-recipients-list-region"
        },

        /**
         * Validate email address
         * @returns {*} the email if valid, null otherwise
         * @private
         */
        _validateInviteEmail: function() {
            var email = this.ui.recipientsAddInput.val();
            return EmailUtil.validateEmail(email) ? email : null;
        },

        _send: function() {
            var recipientNames = this._getSelectedRecipientNames();
            if (recipientNames && this.model.get("message")) {
                var experience = this.model.get("experience");

                var eventProperties = {
                    experienceId: experience.get("id"),
                    experienceVersion: experience.get("version"),
                    experiencePushedVersion: experience.get("pushedVersion"),
                    recipients: recipientNames,
                    message: this.model.get("message"),
                    numberOfRecipients: recipientNames.length,
                    link: this.model.get("route"),
                    triggerOrigin: "SendShareExperienceButton"
                };

                EditorEvents.trigger(EditorEvents.constants.SHARE_EXPERIENCE, eventProperties);
                this.model.set("state", 2);
            }
        },

        _addRecipient: function() {
            var email = this._validateInviteEmail(),
                experience = this.model.get("experience");

            if (email) {
                // Add the recipient, unless it already exists
                var existingRecipient = this.model.get("recipients").find((recipient) => {
                    return recipient.get("email") === email || (recipient.get("user") && recipient.get("user").get("username") === email);
                });

                var eventProperties = {
                    experienceId: experience.get("id"),
                    experienceVersion: experience.get("version"),
                    experiencePushedVersion: experience.get("pushedVersion"),
                    recipientEmail: email,
                    isNewUser: false,
                    triggerOrigin: "ShareMenu"
                };

                if (existingRecipient) {
                    existingRecipient.set("selected", true);
                } else {
                    this.model.get("recipients").add(new ShareRecipient({email: email, selected: true}));
                    this.ui.recipientsList.scrollTop(this.ui.recipientsList.prop("scrollHeight"));
                    eventProperties.isNewUser = true;
                }

                // Trigger event
                EditorEvents.trigger(EditorEvents.constants.ADD_SHARE_EMAIL_RECIPIENT, eventProperties);

                // Reset the button
                this.ui.recipientsAddButton.show();
                this.ui.recipientsAddInputContainer.css("visibility", "hidden");
                this.ui.recipientsAddInput.val("");
            }
        },

        _getSelectedRecipientNames: function() {
            var selectedRecipientNames = [];
            this.model.get("recipients").each((recipient) => {
                if (recipient.get("selected")) {
                    selectedRecipientNames.push(recipient.get("displayName"));
                }
            });
            return selectedRecipientNames.length > 0 ? selectedRecipientNames : null;
        },

        _updateValidationStates: function() {
            // OK button on choose recipients
            if (this._getSelectedRecipientNames()) {
                this.ui.recipientsOkButton.addClass("enabled");
            } else {
                this.ui.recipientsOkButton.removeClass("enabled");
            }

            // Send button on main view
            if (this._getSelectedRecipientNames() && this.model.get("message")) {
                this.ui.sendButton.addClass("enabled");
            } else {
                this.ui.sendButton.removeClass("enabled");
            }
        },

        /**
         * Calling height() on a jQuery element always returns the content height, without any padding or margins, even
         * if the current box sizing model should include them. This method pulls the size from the CSS string, which
         * should always be the correct value.
         *
         * @param {jQuery} element The jQuery element.
         * @returns {Number} The height of the element.
         * @private
         */
        _heightConsideringBoxSizing: function(element) {
            return parseInt(element.css("height").split("px")[0], 10);
        },

        /**
         * Unfortunately the layout we want here is too complicated to do in pure CSS, since we need to overlay the
         * recipients list over the entire menu, which has variable height, and the recipients list itself contains
         * two sections that will vary in height, where we want one of them to fill the remaining space.
         * @private
         */
        _updateRecipientsSizing: function() {
            // Defer to allow other rendering changes to finish first
            _.defer(() => {
                // The height of the entire drop-down should be the top position subtracted from the height of the menu
                var chooseRecipientsHeight = this._heightConsideringBoxSizing(this.$el) - (this.ui.chooseRecipients.offset().top - this.$el.offset().top);
                this.ui.chooseRecipients.css("height", chooseRecipientsHeight + "px");

                // The height of the list is the height of the drop-down minus the height of the add area and footer
                this.ui.recipientsList.css("height", (this.ui.recipientsFooter.offset().top - this.ui.recipientsList.offset().top - this._heightConsideringBoxSizing(this.ui.recipientsAdd)) + "px");
            });
        },

        onRender: function() {
            // Render selected recipients in the to field
            var selectedRecipients = new FilteredCollection(this.model.get("recipients"), ((recipient) => {
                return recipient instanceof ShareRecipientToLabel || recipient.get("selected");
            }));
            this.recipientsDisplay.show(new ShareRecipientDisplayCollectionView({
                collection: new ConcatenatedCollection(new ShareRecipientToLabel({
                    displayName: "To:"
                }), selectedRecipients)
            }));

            // Initially render an empty list of share recipients, then add the registered users when they are loaded
            this.recipientsList.show(new ShareRecipientCollectionView({collection: this.model.get("recipients")}));

            // Load registered users, if the model wasn't already initialized
            if (this.model.get("recipients").isEmpty()) {
                LoggedInUserState.fetchGlobalCollection(UserCollection).done((userCollection) => {
                    // Buffer up the recipients to add
                    var recipientsToAdd = [];

                    // Only take users different from the current user
                    userCollection.each((user) => {
                        if (!LoggedIn.principal().forUser(user)) {
                            recipientsToAdd.push(new ShareRecipient({user: user, email: user.get("username")}));
                        }
                    });

                    // Add the buffered recipients
                    this.model.get("recipients").add(recipientsToAdd);
                });
            }

            this.listenTo(this.model.get("recipients"), "add remove change", this._updateValidationStates);
            this._updateValidationStates();

            this._updateRecipientsSizing();

            _.delay(this.ui.chooseRecipientsWrapper.collapse.bind(this.ui.chooseRecipientsWrapper), 250, "show");
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/share/ShareMenu.js